
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/giftcards/[[...slug]]",
      function () {
        return require("private-next-pages/giftcards/[[...slug]].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/giftcards/[[...slug]]"])
      });
    }
  